export default __webpack_public_path__ + "static/media/tour.c2c51187.png";